/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import React     from 'react';
import PropTypes from 'prop-types';
import Modal     from 'components/Modal/Modal.react';
import FormNote  from 'components/FormNote/FormNote.react';

export default class FormModal extends React.Component {
  constructor() {
    super();
    this.state = {
      errorMessage: '',
      inProgress: false,
    };

    this.handleKey = this.handleKey.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
  }

  componentDidMount() {
    document.body.addEventListener('keydown', this.handleKey);
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.handleKey);
  }

  onCloseClick() {
    this.props.onClose();
  }

  handleKey(e) {
    var keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 27:
        this.onCloseClick(this);
        break;
    }
  }

  render() {
    let {
      children,
      open,
      submitText = 'Confirm',
      inProgressText = 'Confirming\u2026',
      enabled = true,
      onSubmit,
      onSuccess = () => {},
      onClose,
      clearFields = () => {},
      showErrors = true,
      ...modalProps
    } = this.props;
    let showModal = open || this.state.inProgress;
    if (!modalProps.type) {
      if (this.state.errorMessage.length > 0) {
        modalProps.type = Modal.Types.DANGER;
      } else if (enabled) {
        modalProps.type = Modal.Types.VALID;
      }
    }
    return (showModal ? <Modal
      {...modalProps}
      confirmText={this.state.inProgress ? inProgressText : submitText}
      onConfirm={() => {
        this.setState({
          errorMessage: '',
          inProgress: true,
        });

        let p = onSubmit().then(result => {
          onClose();
          clearFields();
          onSuccess(result);
          this.setState({inProgress: false});
        })

        var op = p.catch ? 'catch' : 'fail'
        p[op](({ message, error, notice, errors = [] }) => {
          this.setState({
            errorMessage: errors.join(' ') || message || error || notice || 'An error occurred',
            inProgress: false,
          });
        });
      }}
      onCancel={() => {
        onClose();
        clearFields();
        this.setState({
          errorMessage: '',
        });
      }}
      disabled={!enabled}
      canCancel={!this.state.inProgress}
      progress={this.state.inProgress} >
      {children}
      {showErrors ? <FormNote
        show={this.state.errorMessage.length > 0}
        color='red' >
        {this.state.errorMessage}
      </FormNote> : null}
    </Modal> : null)
  }
}

let { confirmText, onConfirm, onCancel, disabled, canCancel, progress, ...forwardedModalProps} = Modal.propTypes;
FormModal.propTypes = {
  ...forwardedModalProps,
  children: PropTypes.node,
  open: PropTypes.bool.isRequired,
  submitText: PropTypes.string,
  inProgressText: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  clearFields: PropTypes.func,
  enabled: PropTypes.bool,
  showErrors: PropTypes.bool,
};
